export default __webpack_public_path__ + "static/12-200ac024f8fe773d77d9ccbc89f4c9ff.webp";